module.exports = __webpack_public_path__ + "media/registration/workshops@2x-852d5efe.png";